import { DISEASES } from '@/constants/disease'
import store from '@/store'

const summarizedFlow = store.getters['auth/pharmaceuticalDomainConfig'].SUMMARIZEDFLOW

export const COMORBIDITIES_OPTIONS = [
  { key: 'lupus', name: 'Lupus' },
  { key: 'insuficiencia_renal', name: 'Insuficiência renal' },
  { key: 'doenca_lesoes_preexistentes', name: 'Doenças ou Lesões Preexistentes ' },
  { key: 'hipertensao_arterial_sistemica', name: 'Hipertensão Arterial Sistêmica' },
  { key: 'esteatose_hepatica', name: 'Esteatose hepática' },
  { key: 'cirrose_fibrose_hepatica', name: 'Cirrose ou fibrose hepática' },
  {
    key: 'hepatite_b',
    name: 'Hepatite B',
    complex: true,
  },
  {
    key: 'hepatite_c',
    name: 'Hepatite C',
    complex: true,
  },
  {
    key: 'hiv',
    name: 'HIV',
    complex: true,
  },
  { key: 'fibrose_pulmonar', name: 'Fibrose pulmonar' },
  {
    key: 'doenca_inflamatoria_intestinal',
    name: 'Doença inflamatória intestinal',
    disabled: (diseaseId) => diseaseId === DISEASES.ESPONDILOARTRITIS,
  },
  { key: 'dm_intolerancia__glicose', name: 'DM/intolerância à glicose' },
  { key: 'dislipidemia', name: 'Dislipidemia' },
  { key: 'insuficiencia_cardiaca_grau_iii_iv', name: 'Insuficiência cardíaca grau III ou IV' },
  { key: 'esclerose_multipla_doenca_desmielinizante', name: 'Esclerose múltipla ou doença desmielinizante' },
  { key: 'asma', name: 'Asma' },
  {
    key: 'transtorno_depressivo_ansiedade_generalizada',
    name: 'Transtorno depressivo e de ansiedade generalizada',
  },
  { key: 'fibromialgia', name: 'Fibromialgia' },
  { key: 'doenca_auto_imune_reumatologica', name: 'Doença auto-imune/reumatológica' },
  { key: 'cancer_exceto_pele', name: 'Câncer (exceto de pele)' },
  { key: 'rinite_alergica', name: 'Rinite alérgica' },
  { key: 'polipo_nasal_polipose_sinusal', name: 'Pólipo nasal ou diagnóstico de polipose sinusal' },
  { key: 'conjuntivite', name: 'Conjuntivite' },
  { key: 'outras_comorbidades', name: 'Outras comorbidades' },
]
export const COMPLEX_COMORBIDITIES_OPTIONS = [
  { key: 'dermatite_contato', name: 'Dermatite de contato' },
  {
    key: 'alergias',
    name: 'Alergias',
    options: [
      { key: 'alimentar', name: 'Alimentar' },
      { key: 'medicamentos', name: 'Medicamentos' },
      { key: 'contato', name: 'Contato' },
      { key: 'outros', name: 'Outros' },
    ],
  },
  { key: 'neoplasia', name: 'Neoplasia' },
  { key: 'herpes_simples', name: 'Herpes simples' },
  { key: 'erupcao_variceliforme_kaposi', name: 'Erupção variceliforme de Kaposi' },
]

export const PERSONAL_HISTORY_CHRONIC_DISEASES_OPTIONS = [
  { key: 'cancer_pele', name: 'Já teve câncer de pele?' },
  {
    key: 'tipo_cancer_pele',
    name: 'Qual o tipo do câncer de pele?',
    options: [
      { text: 'Carcinoma', value: 'CARCINOMA' },
      { text: 'Melanoma', value: 'MELANOMA' },
      { text: 'Não sei o subtipo', value: 'SEM_SUBTIPO' },
    ],
  },
  {
    key: 'diarreia_cronica',
    name: 'Tem diarreia crônica, dor abdominal ou outras alterações de hábito intestinal?',
    disabled: (diseaseId) => diseaseId === DISEASES.ESPONDILOARTRITIS,
    required: summarizedFlow,
  },
  {
    key: 'uveite',
    name: 'Tem olhos vermelhos, fotofobia, lacrimejamento ou outras alterações visuais (uveíte)?',
    disabled: (diseaseId) => diseaseId === DISEASES.ESPONDILOARTRITIS,
    required: summarizedFlow,
  },
]

export const PERSONAL_HISTORY_HABITS_OPTIONS = [
  {
    key: 'tabagista',
    name: 'É tabagista?',
    options: [
      { text: 'Sim', value: 'SIM' },
      { text: 'Não', value: 'NÃO' },
      { text: 'Prévio', value: 'PRÉVIO' },
    ],
    required: summarizedFlow,
  },
  {
    key: 'etilista',
    name: 'É etilista (consome mais que 2 latas de cerveja ou 1 dose destilado por dia)?',
    options: [
      { text: 'Sim', value: 'SIM' },
      { text: 'Não', value: 'NÃO' },
      { text: 'Prévio', value: 'PRÉVIO' },
    ],
    required: summarizedFlow,
  },
  {
    key: 'drogas_ilicitas_cannabis',
    name: 'Usa cannabis?',
    options: [
      { text: 'Sim', value: 'SIM' },
      { text: 'Não', value: 'NÃO' },
      { text: 'Prévio', value: 'PRÉVIO' },
    ],
    required: summarizedFlow,
  },
  {
    key: 'drogas_ilicitas',
    name: 'Usa outras drogas ilícitas?',
    options: [
      { text: 'Sim', value: 'SIM' },
      { text: 'Não', value: 'NÃO' },
      { text: 'Prévio', value: 'PRÉVIO' },
    ],
    required: summarizedFlow,
  },
]

export const PERSONAL_HISTORY_OBSTETRIC_OPTIONS = [
  {
    key: 'contracepcao',
    name: 'Contracepção?',
    required: summarizedFlow,
  },
  {
    key: 'gravidez',
    name: 'Está grávida ou pretende engravidar durante o tratamento?',
  },
]

export const PERSONAL_HISTORY_PROFILE_OPTIONS = [
  {
    key: 'tuberculose',
    name: 'Já teve ou está com tuberculose ativa?',
    options: [
      { text: 'Sim', value: 'SIM' },
      { text: 'Não', value: 'NÃO' },
      { text: 'Tratada', value: 'TRATADA' },
      { text: 'Em tratamento', value: 'EM_TRATAMENTO' },
    ],
    required: summarizedFlow,
  },
  {
    key: 'tuberculose_latente',
    name: 'Teve exposição prévia ou trabalha exposto a pessoas com possível tuberculose ativa?',
    required: summarizedFlow,
  },
  {
    key: 'tratou_tuberculose',
    name: 'Ja teve tuberculose latente?',
    options: [
      { text: 'Sim', value: 'SIM' },
      { text: 'Não', value: 'NÃO' },
      { text: 'Tratada', value: 'TRATADA' },
      { text: 'Em tratamento', value: 'EM_TRATAMENTO' },
    ],
    required: summarizedFlow,
  },
]

export const CONTRACEPCAO = [
  {
    key: 'aco',
    name: 'ACO',
  },
  {
    key: 'diu_hormonal',
    name: 'DIU hormonal',
  },
  {
    key: 'diu_nao_hormonal',
    name: 'DIU não hormonal',
  },
  {
    key: 'injetavel',
    name: 'Injetável',
  },
  {
    key: 'preservativo ',
    name: 'Preservativo ',
  },
  {
    key: 'coito_interrompido',
    name: 'Coito interrompido',
  },
]

const DA_SUMMARIZED_KEYS = ['tuberculose', 'tratou_tuberculose']

export const PERSONAL_HISTORY_PROFILE_SUMMARIZED_OPTIONS_DA = PERSONAL_HISTORY_PROFILE_OPTIONS.filter((option) =>
  DA_SUMMARIZED_KEYS.includes(option.key),
)
